import { LocationLandingLayout, LocationPageContent } from './LocationLandingLayout'

const content: LocationPageContent = {
  locale: 'tr',
  slug: 'istanbul-bakirkoy-e-ticaret-ajansi',
  meta: {
    title: 'İstanbul Bakırköy E-Ticaret Ajansı | Thinklyze',
    description:
      'Bakırköy\'de e-ticaret büyütmek isteyen işletmeler için tam kapsamlı ajans hizmetleri. Pazaryeri yönetimi, Shopify, e-ticaret reklamcılığı ve büyüme danışmanlığı.',
    keywords: [
      'Bakırköy e-ticaret ajansı',
      'Bakırköy online satış',
      'istanbul bakirkoy trendyol danışmanlık',
      'Bakırköy shopify ajansı',
      'bakirkoy e-ticaret yönetimi',
      'istanbul e-ticaret ajansı',
    ],
    canonical: 'https://thinklyze.com/istanbul-bakirkoy-e-ticaret-ajansi',
  },
  hero: {
    badge: 'Bakırköy E-Ticaret Ajansı',
    title: 'Bakırköy\'deki E-Ticaret İşletmenizi Hızla Büyütün',
    subtitle:
      'Pazaryeri satışlarınızdan kendi mağazanıza, reklam yönetiminden içerik üretimine kadar e-ticaretinizin her boyutunu yönetiyoruz. Bakırköy\'ün güvenilir e-ticaret ajansı olarak somut sonuçlar sunuyoruz.',
    stats: [
      { value: '%250', label: 'Ortalama Gelir Artışı' },
      { value: '50+', label: 'Aktif E-Ticaret Müşterisi' },
      { value: '4.9 ★', label: 'Müşteri Memnuniyeti' },
    ],
    highlights: [
      {
        title: 'Pazaryeri + Kendi Mağaza Stratejisi',
        description:
          'Trendyol ve Hepsiburada\'daki satışlarınızla kendi mağazanızı sinerji halinde büyütüyoruz.',
      },
      {
        title: 'Ürün Listeleme & İçerik Optimizasyonu',
        description:
          'Dönüşüm artıran başlıklar, açıklamalar ve görseller; algoritmayı ve kullanıcıyı aynı anda kazanın.',
      },
      {
        title: 'Tam Kapsamlı Reklam Yönetimi',
        description:
          'Google Shopping, Meta Dynamic Ads ve pazaryeri sponsored reklamlarını tek elde yönetiyoruz.',
      },
    ],
  },
  problemSolution: {
    title: 'Bakırköy\'deki E-Ticaret İşletmelerinin Sorunları',
    items: [
      {
        title: 'Pazaryerinde satışlar durağan',
        description:
          'Yeni ürün eklemek yetmiyor, algoritma size yüz vermiyor. Mağaza skoru, kategori optimizasyonu ve reklam stratejisiyle satışları yeniden büyütüyoruz.',
      },
      {
        title: 'Kendi e-ticaret sitesi trafik almıyor',
        description:
          'Organik trafik yoksa pahalı reklam trafiğine mahkumsunuz. SEO ve içerik stratejisiyle sürdürülebilir organik büyüme sağlıyoruz.',
      },
      {
        title: 'Marj çok düşük, rekabet çok yüksek',
        description:
          'Fiyat rekabeti yapmak yerine marka değeri ve içerik kalitesiyle farklılaşmak kâr marjını korur. Bu ayrışmayı birlikte yaratıyoruz.',
      },
      {
        title: 'Operasyon çok karmaşık, zaman yok',
        description:
          'Stok yönetimi, sipariş takibi, müşteri hizmetleri ve reklam optimizasyonu aynı anda yönetilemiyor. Otomasyon ve outsourcing çözümleriyle yükü azaltıyoruz.',
      },
    ],
  },
  services: {
    title: 'Bakırköy E-Ticaret Ajansı Hizmetleri',
    items: [
      {
        title: 'Trendyol & Hepsiburada Yönetimi',
        description:
          'Mağaza kurulumu, ürün yükleme, optimizasyon, kampanya yönetimi ve müşteri yorumları yönetimi.',
      },
      {
        title: 'Shopify & WooCommerce Mağaza',
        description:
          'Kendi e-ticaret altyapınızı kuruyor, ödeme sistemlerini entegre ediyor ve dönüşüm için optimize ediyoruz.',
      },
      {
        title: 'E-Ticaret SEO',
        description:
          'Kategori ve ürün sayfaları için organik arama trafiği çeken SEO stratejileri.',
      },
      {
        title: 'Google Shopping & Meta Dynamic Ads',
        description:
          'Ürün bazlı reklam kampanyalarıyla en yüksek satın alma niyetiyle arayanları yakalayın.',
      },
      {
        title: 'E-Posta & SMS Otomasyonu',
        description:
          'Sepet terk, sipariş sonrası upsell ve müşteri sadakat kampanyalarıyla tekrar satışları artırın.',
      },
      {
        title: 'Büyüme Danışmanlığı',
        description:
          'Hangi kategoriye odaklanmalı, hangi kanala ne kadar bütçe ayırmalısınız? Veriye dayalı büyüme yol haritanızı birlikte çiziyoruz.',
      },
    ],
  },
  locationBenefits: {
    title: 'Bakırköy\'de Yerel E-Ticaret Ajansıyla Çalışmanın Avantajları',
    items: [
      {
        title: 'Yerinde Destek & Ziyaret',
        description:
          'Bakırköy merkezli ofisimizden stok fotoğrafı çekimi, ürün içerik üretimi için yerinde destek verebiliyoruz.',
      },
      {
        title: 'Anlık İletişim',
        description:
          'WhatsApp, e-posta veya yüz yüze; iletişim kanalını siz seçin. İş saatlerinde 2 saat içinde yanıt garantisi.',
      },
      {
        title: 'Avrupa Yakası Lojistik Bilgisi',
        description:
          'Bakırköy çevresindeki lojistik ve depo imkânlarını bilen ekibimiz operasyonunuza stratejik katkı sağlar.',
      },
      {
        title: 'Küçük Bütçeyle Başlanabilir',
        description:
          'Her büyüklükteki işletmeye uygun esnek paketler. Büyüdükçe hizmet kapsamını birlikte genişletiyoruz.',
      },
      {
        title: 'Çok Sektörlü Bakırköy Deneyimi',
        description:
          'Bakırköy\'deki tekstil, gıda, hizmet ve teknoloji işletmelerine başarılı projeler teslim ettik.',
      },
      {
        title: 'Entegre Dijital Hizmetler',
        description:
          'E-ticaret, sosyal medya, reklam ve web tasarım hizmetlerini tek noktadan alarak entegrasyon avantajı elde edin.',
      },
    ],
  },
  faqs: [
    {
      question: 'Bakırköy\'de yeni bir e-ticaret işine başlamak istiyorum, nereden başlamalıyım?',
      answer:
        'Önce pazar araştırması ve rakip analizi yapıyoruz, ardından kanal stratejisini (pazaryeri mi, kendi site mi, ikisi birden mi) belirliyoruz. Ücretsiz keşif görüşmesinde başlangıç yol haritanızı çiziyoruz.',
    },
    {
      question: 'Trendyol ve Hepsiburada\'da aynı anda yönetim yapıyor musunuz?',
      answer:
        'Evet. Çok kanallı e-ticaret yönetimi temel hizmetlerimizden biri. Stok senkronizasyonu ve tutarlı içerik yönetimiyle her iki platformu koordineli şekilde yönetiyoruz.',
    },
    {
      question: 'E-ticaret ajansı ücreti nasıl hesaplanıyor?',
      answer:
        'Hizmet kapsamına göre sabit aylık yönetim ücreti veya ciro bazlı performans modelleri sunuyoruz. Keşif görüşmesinde işletmenize en uygun modeli belirliyoruz.',
    },
    {
      question: 'Ürün fotoğrafı çekimi hizmeti veriyor musunuz?',
      answer:
        'Evet, iş ortakları aracılığıyla Bakırköy\'de ürün fotoğrafı ve video çekimi organizasyonu sağlıyoruz.',
    },
  ],
  cta: {
    badge: 'Bakırköy E-Ticaret',
    title: 'E-Ticaret Satışlarınızı Birlikte Büyütelim',
    description:
      'Ücretsiz e-ticaret analizi için bugün randevu alın. Mevcut kanallarınızı, rakip konumlandırmanızı ve 90 günlük büyüme planınızı birlikte oluşturuyoruz.',
  },
  areaServed: ['Bakırköy', 'Bahçelievler', 'Bağcılar', 'Küçükçekmece', 'Zeytinburnu', 'İstanbul'],
  coordinates: { latitude: 40.9811, longitude: 28.8726 },
  address: {
    streetAddress: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
    addressLocality: 'Bakırköy',
    addressRegion: 'İstanbul',
    postalCode: '34140',
    addressCountry: 'TR',
  },
  relatedServices: {
    title: 'İlgili Hizmetlerimiz',
    items: [
      { name: 'Pazaryeri Yönetimi', href: '/services/marketplace', description: 'Trendyol ve Hepsiburada\'da büyüme.' },
      { name: 'Shopify Danışmanlığı', href: '/shopify', description: 'Kendi e-ticaret mağazanızı kurun ve büyütün.' },
      { name: 'Google Ads', href: '/services/google-ads', description: 'E-ticaret için Shopping kampanyaları.' },
      { name: 'Web Tasarım', href: '/services/web-design', description: 'Dönüşüm odaklı mağaza tasarımı.' },
    ],
  },
}

const IstanbulBakirkoyETicaretAjansi = () => {
  return <LocationLandingLayout content={content} />
}

export default IstanbulBakirkoyETicaretAjansi
